import React, { useState, useEffect } from 'react';
import { storage } from '../utils/storage';

const assessments = {
  personality: {
    title: "Personality Assessment",
    questions: [
      { question: "How do you prefer to work?", options: ["Alone", "In small teams", "In large groups", "It depends on the task"] },
      { question: "When making decisions, you rely more on:", options: ["Logic and facts", "Intuition and feelings", "Past experience", "Others' opinions"] },
      { question: "Your ideal work environment is:", options: ["Structured and organized", "Flexible and creative", "Fast-paced and dynamic", "Quiet and focused"] },
      { question: "How do you handle stress?", options: ["Stay calm and focused", "Take breaks frequently", "Seek help from others", "Work through it quickly"] }
    ]
  },
  skills: {
    title: "Skills Assessment",
    questions: [
      { question: "Rate your communication skills:", options: ["Excellent", "Good", "Average", "Needs improvement"] },
      { question: "How comfortable are you with technology?", options: ["Very comfortable", "Somewhat comfortable", "Basic knowledge", "Not comfortable"] },
      { question: "Your problem-solving approach is:", options: ["Analytical and systematic", "Creative and innovative", "Collaborative", "Trial and error"] },
      { question: "Rate your leadership abilities:", options: ["Strong leader", "Good team player", "Prefer to follow", "Situational"] }
    ]
  },
  interests: {
    title: "Career Interests",
    questions: [
      { question: "Which activity interests you most?", options: ["Analyzing data", "Creating content", "Helping people", "Managing projects"] },
      { question: "Your ideal work involves:", options: ["Working with numbers", "Working with people", "Working with ideas", "Working with things"] },
      { question: "What motivates you most at work?", options: ["Financial rewards", "Recognition", "Personal growth", "Making a difference"] }
    ]
  },
  tech: {
    title: "Tech Industry Assessment",
    questions: [
      { question: "Your programming experience level:", options: ["Expert (5+ years)", "Intermediate (2-5 years)", "Beginner (0-2 years)", "No experience"] },
      { question: "Preferred development approach:", options: ["Frontend/UI", "Backend/Systems", "Full-stack", "Data/Analytics"] },
      { question: "How do you stay updated with tech trends?", options: ["Daily tech news", "Online courses", "Conferences/meetups", "Learning on the job"] }
    ]
  },
  healthcare: {
    title: "Healthcare Assessment",
    questions: [
      { question: "Your healthcare experience:", options: ["Medical professional", "Healthcare support", "Administrative", "No experience"] },
      { question: "Patient interaction preference:", options: ["Direct patient care", "Behind-the-scenes support", "Emergency situations", "Long-term relationships"] },
      { question: "Healthcare setting preference:", options: ["Hospital", "Clinic", "Research facility", "Home care"] }
    ]
  },
  finance: {
    title: "Finance Assessment",
    questions: [
      { question: "Your finance background:", options: ["Extensive experience", "Some experience", "Academic knowledge", "No experience"] },
      { question: "Preferred finance area:", options: ["Investment banking", "Personal finance", "Corporate finance", "Risk management"] },
      { question: "Your approach to financial decisions:", options: ["Data-driven analysis", "Market intuition", "Conservative planning", "Collaborative discussion"] }
    ]
  }
};

function Assessment({ type, currentUser, onComplete }) {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const assessment = assessments[type];
  const progress = ((currentQuestion + 1) / assessment.questions.length) * 100;

  const selectOption = (index) => {
    setSelectedOption(index);
  };

  const nextQuestion = () => {
    if (selectedOption === null) return;
    
    const newAnswers = [...answers, selectedOption];
    setAnswers(newAnswers);
    setSelectedOption(null);
    
    if (currentQuestion + 1 < assessment.questions.length) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      completeAssessment(newAnswers);
    }
  };

  const completeAssessment = async (finalAnswers) => {
    const results = {
      type,
      title: assessment.title,
      answers: finalAnswers,
      date: new Date().toISOString()
    };

    // Save to Vercel KV
    await storage.addAssessment(currentUser, results);
    onComplete(results);
  };

  const question = assessment.questions[currentQuestion];

  return (
    <div id="assessment-container">
      <div id="question-container">
        <h2>{assessment.title}</h2>
        <div id="progress-bar">
          <div id="progress" style={{ width: `${progress}%` }}></div>
        </div>
        <div id="question">{question.question}</div>
        <div id="options">
          {question.options.map((option, index) => (
            <div 
              key={index}
              className={`option ${selectedOption === index ? 'selected' : ''}`}
              onClick={() => selectOption(index)}
            >
              {option}
            </div>
          ))}
        </div>
        <button 
          id="next-btn" 
          onClick={nextQuestion}
          disabled={selectedOption === null}
        >
          {currentQuestion + 1 === assessment.questions.length ? 'Complete' : 'Next'}
        </button>
      </div>
    </div>
  );
}

export default Assessment;